import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetStatsEnvironment } from '../fleet-stats-environment';
import { deviceStatsLocationDetailsSchema } from '../schemas/device-stats-location-details.schema';

/**
 * Gets all device location details
 * @returns Device location details
 */
export function getDashboardDeviceStatsLocationDetails(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetStatsEnvironment.resolve(this).dashboardDeviceStatsLocationDetails,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(z.array(deviceStatsLocationDetailsSchema)));
}
